/* Who may use Discover (and through it, MAP's Curation pages).

   Curation is limited, not switched off: only people with the platform_admin role reach it.
   Everyone else sees Discover on the hub as "Platform admins", and any Curation URL sends them
   back to the hub. The role is read from the sign-in token (the same role MAP passes to
   getPermissionsbyrole), plus the roles MAP has already stored for the session. */

export const CURATION_ROLE = "platform_admin";
export const CURATION_DENIED = "Discover is open to platform admins only.";

export function rolesOf(auth: any): string[] {
  const out = new Set<string>();
  const meta = auth?.appMetadata ? Object.values(auth.appMetadata) : [];
  meta.forEach((t: any) => (Array.isArray(t?.roles) ? t.roles : []).forEach((r: string) => r && out.add(r)));
  try { (localStorage.getItem("userRole") || "").split(",").forEach((r) => r && out.add(r.trim())); } catch { /* storage unavailable */ }
  return Array.from(out);
}

export const canCurate = (auth: any) => rolesOf(auth).includes(CURATION_ROLE);

/** Routes that stay open to everyone: the way in and ONAM. Every other MAP page belongs to Curation. */
export function isCurationPath(pathname: string) {
  const p = (pathname || "").toLowerCase();
  return !(p === "/" || p.startsWith("/home") || p.startsWith("/entry-hub") || p.startsWith("/onam"));
}
